<div class="ne-container" data-test-component="note">

  <svg class="ne-svg" xmlns="http://www.w3.org/2000/svg" width="{svgWidth}" height="{svgHeight}" viewBox="0 0 {svgWidth} {svgHeight}" xml:space="preserve" xmlns:xlink="http://www.w3.org/1999/xlink">
    {#if isPreview}
      <defs>
        <clipPath id="clipPath">
          <rect x="0" y="19.91" width="300.14" height="380.85"></rect>
        </clipPath>
      </defs>
    {/if}

    <Border/>
    <g style="{isPreview ? 'clip-path: url(#clipPath);' : ''}">
      <svg id="print-svg" bind:this={printSvg} class="ne-svg" xmlns="http://www.w3.org/2000/svg" width="{svgWidth}" height="{svgHeight}" viewBox="0 0 {svgWidth} {svgHeight}" xml:space="preserve" xmlns:xlink="http://www.w3.org/1999/xlink">
        <slot></slot>
      </svg>
    </g>
  </svg>
</div>

<style>
  .ne-svg {
    overflow: visible;
  }

  .ne-container {
    width: 100%;
    display: inline-block;
  }
</style>

<script>
  import Border from './Border.html';
  import { SVG_HEIGHT, SVG_WIDTH } from '../lib/constants';
  import { onMount } from 'svelte';

  let printSvg;
  let svgWidth = SVG_WIDTH;
  let svgHeight = SVG_HEIGHT;

  export let setPrintSvg;
  export let isPreview = false;

  onMount(() => {
    setPrintSvg(printSvg);
  });
</script>
